/**
 * Staun Helpers
 * Shared utility functions. Loaded globally with defer.
 * No inline scripts — this file is loaded via staun-head.liquid.
 */

'use strict';

const StaunHelpers = (() => {
  /**
   * Debounce function execution
   * @param {Function} fn - Function to debounce
   * @param {number} delay - Delay in milliseconds
   * @returns {Function}
   */
  const debounce = (fn, delay = 250) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(null, args), delay);
    };
  };

  /**
   * Check if element is in viewport
   * @param {Element} el - DOM element
   * @param {number} threshold - Visibility threshold (0-1)
   * @returns {boolean}
   */
  const isInViewport = (el, threshold = 0) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < (window.innerHeight || document.documentElement.clientHeight) * (1 + threshold) &&
      rect.bottom > 0
    );
  };

  /**
   * Format currency for AUD
   * @param {number} cents - Amount in cents
   * @returns {string}
   */
  const formatMoney = (cents) => {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  };

  return { debounce, isInViewport, formatMoney };
})();
